import React from 'react';
import { Input, message } from 'antd';
import setRequiredFields from './GaokaoxkStore';
import { observer } from 'mobx-react-lite';

const Grade = (props) => {
    const { areaName } = props;

    // 根据 diqu 和 pici 动态获取最大值
    const getMaxGrade = () => {
        if (areaName[0] === '北京' && areaName[1] === '本科批') return 750;
        if (areaName[0] === '北京' && areaName[1] === '专科批') return 450;
        if (areaName[0] === '上海' && areaName[1] === '本科批') return 660;
        if (areaName[0] === '上海' && areaName[1] === '专科批') return 450;
        if (areaName[0] === '天津' && areaName[1] === '本科批') return 750;
        if (areaName[0] === '天津' && areaName[1] === '专科批') return 450;
        if (areaName[0] === '海南') return 900;
        return 750;
    };

    const handleInputChange = (e) => {
        let value = e.target.value.replace(/[^\d]/g, '');
        const maxGrade = getMaxGrade();

        if (value) {
            if (parseInt(value, 10) > maxGrade) {
                message.warning(`最大输入范围为 1-${maxGrade}`);
                value = value.slice(0, maxGrade.toString().length);
            }

            if (parseInt(value, 10) < 1) {
                message.warning('最小输入范围为 1');
                value = '1';
            }
        }

        setRequiredFields.setRequiredFields({ grade: value });
    };

    return (
        <>
            {/* 添加全局样式 - 关键修改在这里 */}
            <style>{`
                .custom-grade-input::placeholder {
                    color: #006AFF !important;
                    opacity: 0.5 !important; /* 直接设置透明度为 50% */
                }
                .custom-grade-input:focus {
                    outline: none !important;
                    border: 1px solid #006AFF !important;
                    box-shadow: none !important; /* 添加这行移除阴影 */
                }
                /* 移除Ant Design默认的聚焦样式 */
                .custom-grade-input:focus-within {
                    box-shadow: none !important;
                    border-right-width: 1px !important;
                }
            `}</style>

            <Input
                placeholder="分数"
                className="custom-grade-input"
                style={{
                    width: '52px',
                    height: '38px',
                    border: 'none',
                    backgroundColor: '#F4F9FF',
                    color: '#006AFF',
                    borderRadius: '4px',
                    padding: '4px 11px',
                    margin: 0,
                    fontWeight: (setRequiredFields.requiredFields.grade !== '' && 
                                setRequiredFields.requiredFields.grade !== null) ? 700 : 400
                }}
                value={setRequiredFields.requiredFields.grade || ''}
                onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                    }
                }}
                onPaste={(e) => {
                    const pasteData = e.clipboardData.getData('text');
                    if (!/^\d*$/.test(pasteData)) {
                        message.warning('只能输入数字');
                        e.preventDefault();
                    }
                }}
                onChange={handleInputChange}
            />
        </>
    );
};

export default observer(Grade);